/* eslint-disable no-undef */
import { apiPost } from '@/utils/request';

export function login(params) {
  return apiPost(`${BASE_API_URL}/TokenAuth/Authenticate`, { body: params });
}

export function logout() {}
